import { IconChartLine } from '@rossum/ui/icons/tabler';
import InfoPlaceholder from '../../../../components/UI/InfoPlaceHolder';
import { LocalizationKeys } from '../../../../i18n';

type EmptyChartProps = {
  title: LocalizationKeys;
  text?: LocalizationKeys;
};

const EmptyChart = ({ title, text }: EmptyChartProps) => (
  <InfoPlaceholder title={title} text={text} icon={IconChartLine} inTable />
);

export { EmptyChart };
